import React from 'react'
import ProdIOOExoViewRow from './ProdIOOExoViewRow'
import FormLabel from '../../../../../library/form/components/FormLabel';
import FormWrapper from '../../../../../library/form/components/FormWrapper';
import withView from '../../../../cmn/docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormSearchButton from '../../../../../library/form/components/FormSearchButton';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../../../library/layout/Index";

const ProdIOOExoView = (props) => {
    const { formObject, viewData } = props;

    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline"><SarasTrans value = "Output"/></span>
                    </UiTitle>
                    <UiAction>
                        <FormButton formObject={formObject} headerKey="viewConfig" className="uiActionButton"
                            action={{ actionId: "new", 
                            paramName: "addBOMBtn",
                            actionParam: {actionType : "addBOMItem", pathKey:"OEXO", viewKey:"addBOMItem"}, 
                            containerKey: "popup" }}
                            text={<SarasTrans value="Add Stock from BOM" />}>
                        </FormButton>
                        <div className="uiSpacerH10"></div>
                        <FormWrapper customWrapper="span" formObject={formObject} headerKey="viewConfig" 
                            action={{ paramName: "addAdhocBtn" }} >
                            <FormSearchButton formObject={formObject} rowKey="" headerKey='lineItemLink'
                                action={{ actionId: "new", 
                                loadEditorAfterAdd: 1,
                                actionParam: {actionType : "addItem", pathKey: "OEXO"} }}
                                className='uiActionButton uiSpacerH10' placeholder="Barcode or Item Id"
                            />
                        </FormWrapper>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr No." /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnCenter uiColumn250"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig" 
                                    action={{ paramName: "variation1Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                                </FormWrapper>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig" 
                                    action={{ paramName: "variation2Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                                </FormWrapper>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Qty Expected" /></li>
                                <FormWrapper formObject={formObject} headerKey="viewConfig" action={{ paramName: "showCost" }} >
                                    <li className="uiColumnCenter uiColumn90"><SarasTrans value="Item Unit Cost" /></li>
                                    <li className="uiColumnCenter uiColumn90"><SarasTrans value="Labor Unit Cost" /></li>
                                    <li className="uiColumnCenter uiColumn90"><SarasTrans value="OH Unit Cost" /></li>
                                    <li className="uiColumnCenter uiColumn90"><SarasTrans value="Total Unit Cost" /></li>
                                </FormWrapper>
                                <li className="uiColumnCenter uiColumn60"><SarasTrans value="Action" /> </li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><ProdIOOExoViewRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1}/></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProdIOOExoView, "prodEOOutput", "prodEOOutputGroup,prodEOSum");
